import styles from "./AccountsToolbar.module.scss";
import {
  CalendarDateIcon,
  CreditCard02Icon,
  SearchSmIcon,
  UserPlus01Icon,
  Users01Icon,
} from "@vetty/icons";
import { Button, Input, Select } from "@/components";
import {
  ACCOUNT_PERIOD_OPTIONS,
  ACCOUNT_ROLE_TAB_ITEMS,
  ACCOUNT_SUBSCRIPTION_OPTIONS,
} from "../../_constants/accounts.const";
import type {
  AccountPeriodFilter,
  AccountRoleFilter,
  AccountSubscriptionFilter,
} from "../../_types/accounts.types";

type AccountsToolbarProps = {
  role: AccountRoleFilter;
  subscription: AccountSubscriptionFilter;
  period: AccountPeriodFilter;
  search: string;
  onRoleChange: (value: AccountRoleFilter) => void;
  onSubscriptionChange: (value: AccountSubscriptionFilter) => void;
  onPeriodChange: (value: AccountPeriodFilter) => void;
  onSearchChange: (value: string) => void;
  onCreateAccountClick: () => void;
};

export const AccountsToolbar = ({
  role,
  subscription,
  period,
  search,
  onRoleChange,
  onSubscriptionChange,
  onPeriodChange,
  onSearchChange,
  onCreateAccountClick,
}: AccountsToolbarProps) => {
  return (
    <div className={styles["comp"]}>
      <div className={styles["comp__left"]}>
        <Select
          size="medium"
          variant="secondary"
          value={role}
          startContent={<Users01Icon style={{ width: 20, height: 20 }} />}
          onChange={(value) => onRoleChange(value as AccountRoleFilter)}
        >
          {ACCOUNT_ROLE_TAB_ITEMS.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Select>

        <Select
          size="medium"
          variant="secondary"
          value={subscription}
          startContent={<CreditCard02Icon style={{ width: 20, height: 20 }} />}
          onChange={(value) =>
            onSubscriptionChange(value as AccountSubscriptionFilter)
          }
        >
          {ACCOUNT_SUBSCRIPTION_OPTIONS.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Select>

        <Select
          size="medium"
          variant="secondary"
          value={period}
          startContent={<CalendarDateIcon style={{ width: 20, height: 20 }} />}
          onChange={(value) => onPeriodChange(value as AccountPeriodFilter)}
        >
          {ACCOUNT_PERIOD_OPTIONS.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Select>

        <div className={styles["comp__search"]}>
          <Input
            id="accounts-search"
            value={search}
            placeholder="Search by email, name, username…"
            variant="secondary"
            size="medium"
            startContent={<SearchSmIcon style={{ width: 20, height: 20 }} />}
            onChange={(value) => onSearchChange(value)}
          />
        </div>
      </div>

      <div className={styles["comp__actions"]}>
        <Button
          size="medium"
          variant="primary"
          startContent={<UserPlus01Icon style={{ width: 20, height: 20 }} />}
          onClick={onCreateAccountClick}
        >
          Create account
        </Button>
      </div>
    </div>
  );
};
